import { render, staticRenderFns } from "./UserFarmTable.vue?vue&type=template&id=8ae46e66"
import script from "./UserFarmTable.vue?vue&type=script&lang=js"
export * from "./UserFarmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports